import { useState } from 'react';
import { useSelector } from 'react-redux';
import { LabelBold, ToggleSwitch } from '@comeon/ui';
import { selectCurrency } from '~/components/account/ducks';
import usePaypalOrderRef from '~/components/payment/hooks/use-paypal-order-ref.js';

import { LOADING } from '../utils/constants.js';
import { StyledToggle, PaymentButtonSecondary, PaypalModalWrapper } from '../utils/qd-styled-utils.js';

const QDPaypalscreen = ({ translation: t, views, executeQDDeposit }) => {
	const [enableOneClick, toggleAggr] = useState(false);
	const currency = useSelector(selectCurrency);
	const { status, OrderFuniquedID } = usePaypalOrderRef(true);
	const setOneClickandExecute = () => {
		executeQDDeposit({ OrderFuniquedID: OrderFuniquedID.current, enableOneClick, cu: currency });
	};

	return (
		<PaypalModalWrapper>
			<StyledToggle className="quick-deposit-cvv-wrapper">
				<ToggleSwitch toggleClass="cookie-toggle" onClick={() => toggleAggr(!enableOneClick)} />
				<LabelBold className="u-pt1 u-pl1">{t.QD_PAYPAL_ONECLICK}</LabelBold>
			</StyledToggle>
			<PaymentButtonSecondary
				smallfont
				disabled={views.includes(LOADING) || status !== 'ready'}
				onClick={setOneClickandExecute}
				type="submit"
				className="button u-mb1 u-mt1"
				title="title"
				dataAt="mobile-quick-deposit-button"
			>
				{t.QD_PAYPAL_CONTINUE}
			</PaymentButtonSecondary>
		</PaypalModalWrapper>
	);
};

export default QDPaypalscreen;
